<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M461.7 481.4c0 13.1-8.7 23.6-19.5 23.7l-372.4.4c-10.8 0-19.5-10.6-19.5-23.6l-.4-451.8c0-13.1 8.7-23.6 19.5-23.7l274-.3 118 110.7.3 364.6z" fill="#e6e6e6" />
      <path fill="none" d="M50 6h412v500H50z" />
      <path d="m461.7 119.7-99.4.1c-10.8 0-19.5-10.6-19.5-23.6L342.7 9l119 110.7zm-99.1 61.1c-4.1-3.2-9.8-5-15.7-5H165.2c-5.9 0-11.5 1.8-15.7 5s-6.5 7.6-6.5 12.1v6.8c0 4.6 2.4 8.9 6.5 12.1 4.1 3.2 9.8 5 15.7 5h181.7c5.9 0 11.5-1.8 15.7-5 4.2-3.2 6.5-7.6 6.5-12.1v-6.8c0-4.5-2.4-8.9-6.5-12.1zm0 94c-4.1-3.2-9.8-5-15.7-5H165.1c-5.9 0-11.5 1.8-15.7 5s-6.5 7.6-6.5 12.1v6.8c0 4.5 2.4 8.8 6.5 12.1 4.1 3.2 9.8 5 15.7 5h181.8c5.9 0 11.5-1.8 15.7-5s6.5-7.6 6.5-12.1v-6.8c0-4.5-2.4-8.8-6.5-12.1zm0 93.9c-4.1-3.2-9.8-5-15.7-5H165.1c-5.9 0-11.5 1.8-15.7 5s-6.5 7.6-6.5 12.1v6.8c0 4.5 2.4 8.9 6.5 12.1 4.1 3.2 9.8 5 15.7 5h181.8c5.9 0 11.5-1.8 15.7-5s6.5-7.6 6.5-12.1v-6.8c0-4.6-2.4-8.9-6.5-12.1z" fill="#b8b8b8" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
